module.exports = __webpack_public_path__ + "img/Couple.a4604602.svg";